/**
 * Extracts the first <img> tag from HTML string
 * Returns the img attributes and the remaining HTML without the img
 */
export function extractFirstImg(html: string): {
  imgProps: {
    src: string;
    width?: string;
    height?: string;
    alt?: string;
    'data-content'?: string;
  } | null;
  remainingHtml: string;
} {
  if (!html) return { imgProps: null, remainingHtml: html };

  // Find the first <img> tag (self-closing or with closing tag)
  const imgRegex = /<img[^>]*>/i;
  const match = html.match(imgRegex);

  if (!match) {
    return { imgProps: null, remainingHtml: html };
  }

  const imgHtml = match[0];
  const remainingHtml = html.replace(imgRegex, '').trim();

  // Parse img attributes
  const srcMatch = imgHtml.match(/src=["']([^"']+)["']/i);
  const widthMatch = imgHtml.match(/width=["']?(\d+)["']?/i);
  const heightMatch = imgHtml.match(/height=["']?(\d+)["']?/i);
  const altMatch = imgHtml.match(/alt=["']([^"']*)["']/i);
  const dataContentMatch = imgHtml.match(/data-content=["']([^"']+)["']/i);

  const imgProps = {
    src: srcMatch ? srcMatch[1] : '',
    width: widthMatch ? widthMatch[1] : undefined,
    height: heightMatch ? heightMatch[1] : undefined,
    alt: altMatch ? altMatch[1] : undefined,
    'data-content': dataContentMatch ? dataContentMatch[1] : undefined,
  };

  return { imgProps, remainingHtml };
}
